import { useState } from "react";
import DratCaseStatusParent from "./DratCaseStatus/DratCaseStatusParent";
import DrtCaseStatusParent from "./DrtCaseStatus/DrtCaseStatusParent";
import RcTrcCaseStatusParent from "./RcTrcCaseStatus/RcTrcCaseStatusParent";

const CaseDEtailParent = () => {
  const [relatedLink, setRelatedLink] = useState("DratCaseStatus");

  return (
    <div>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-4 p-0">
          <ul className="nav toptab-two mb-3" id="v-pills-tab" role="tablist">
            {/* DRAT Case Status */}
            <li className="nav-item" role="presentation">
              <a
                className={
                  relatedLink === "DratCaseStatus" ? "nav-link active" : "nav-link"
                }
                id="tab-drat-status"
                role="tab"
                aria-controls="panel-drat-status"
                aria-selected={relatedLink === "DratCaseStatus"}
                onClick={() => setRelatedLink("DratCaseStatus")}
              >
                DRAT Case Status
              </a>
            </li>

            {/* DRT Case Status */}
            <li className="nav-item" role="presentation">
              <a
                className={
                  relatedLink === "DrtCaseStatus" ? "nav-link active" : "nav-link"
                }
                id="tab-drt-status"
                role="tab"
                aria-controls="panel-drt-status"
                aria-selected={relatedLink === "DrtCaseStatus"}
                onClick={() => setRelatedLink("DrtCaseStatus")}
              >
                DRT Case Status
              </a>
            </li>

            {/* RC/TRC Case Status */}
            <li className="nav-item" role="presentation">
              <a
                className={
                  relatedLink === "RcTrcCaseStatus" ? "nav-link active" : "nav-link"
                }
                id="tab-rctrc-status"
                role="tab"
                aria-controls="panel-rctrc-status"
                aria-selected={relatedLink === "RcTrcCaseStatus"}
                onClick={() => setRelatedLink("RcTrcCaseStatus")}
              >
                RC/TRC Case Status
              </a>
            </li>
          </ul>
        </div>

        <div className="col-12 col-sm-12 col-md-12 col-lg-8 pr-0">
          <div className="tab-content tab-form" id="v-pills-tabContent">
            {relatedLink === "DratCaseStatus" && (
              <div
                className="tab-pane fade show active"
                id="panel-drat-status"
                role="tabpanel"
                aria-labelledby="tab-drat-status"
              >
                <DratCaseStatusParent />
              </div>
            )}

            {relatedLink === "DrtCaseStatus" && (
              <div
                className="tab-pane fade show active"
                id="panel-drt-status"
                role="tabpanel"
                aria-labelledby="tab-drt-status"
              >
                <DrtCaseStatusParent />
              </div>
            )}

            {relatedLink === "RcTrcCaseStatus" && (
              <div
                className="tab-pane fade show active"
                id="panel-rctrc-status"
                role="tabpanel"
                aria-labelledby="tab-rctrc-status"
              >
                <RcTrcCaseStatusParent />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseDEtailParent;
